/*
 *+------------------------------------------------------------------------+
 *| Licensed Materials - Property of IBM
 *| IBM Cognos Products: Explore
 *| (C) Copyright IBM Corp. 2019, 2020
 *|
 *| US Government Users Restricted Rights - Use, duplication or disclosure
 *| restricted by GSA ADP Schedule Contract with IBM Corp.
 *+------------------------------------------------------------------------+
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import { Flyout } from '@ba/ba-ui-carbon-toolkit';
import StringResources from '../../../nls/StringResources';

const HELP_DOC_URL = 'https://www.ibm.com/support/knowledgecenter/SSEP7J_11.1.0/com.ibm.swg.ba.cognos.ca_explorations.doc/ca_explore_relationship_strength_slider.html';

@observer
class RelationshipInfoTooltip extends Component {
	constructor(props) {
		super(props);
	}

	componentDidMount = () => {
		this._onScrollhandler = this._onScroll;
		window.addEventListener('scroll', this._onScrollhandler, true);
	}

	componentWillUnmount = () => {
		if (this._onScrollhandler) {
			window.removeEventListener('scroll', this._onScrollhandler, true);
			this._onScrollhandler = null;
		}
	}

	_onScroll = () => {
		this._onFlyoutClose();
	}

	_onFlyoutClose = () => {
		if(this.props.onClose) {
			this.props.onClose();
		}
	}

	render = () => {
		let content = null;
		if (this.props.isOpen) {
			const triggerNode = this.props.triggerNode;
			const textContent = StringResources.get('relationshipGraph_informationText');
			const readMoreText = StringResources.get('relationshipGraph_informationText_readMore');
			content = (
				<Flyout
					title={StringResources.get('relationshipGraph_filterStrength_label')}
					placement={'topCentred'}
					showX={true}
					padding={'default'}
					domNodeToAttachTo={document.body}
					triggerNode={triggerNode}
					textContent={textContent}
					href={HELP_DOC_URL}
					linkName={readMoreText}
					onClose={this._onFlyoutClose}
				/>
			);
		}

		return content;
	}
}

RelationshipInfoTooltip.propTypes = {
	isOpen: PropTypes.boolean,
	triggerNode: PropTypes.object.isRequired,
	onClose: PropTypes.func
};

export default RelationshipInfoTooltip;



// WEBPACK FOOTER //
// ./src/js/components/startingPoints/relationshipGraph/RelationshipInfoTooltip.js